module.exports = __webpack_public_path__ + "static/media/Spiderman.ec26c3e2.jpg";